<template>
  <div>
    <banner />
    <search-bar />
    <results />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import slugify from "slugify";

import Banner from "../elements/DirectoryBanner.vue"
import SearchBar from "../elements/SearchBars/DirectorySearchBar.vue"
import Results from "../elements/results/Results.vue"

export default {
  name: "Directory",
  data() {
    return {
      msg: slugify("Directory page", { lower: true })
    };
  },
  components: {
    banner: Banner,
    'search-bar' :SearchBar,
    results: Results
  },
  computed: {
    ...mapGetters([
      "currentResults",
      "results",
      "capitalTypes",
      "providerTypes",
      "sectors",
      "devCountries",
      "getSelectedCapitalTypes",
      "getSelectedProviderTypes",
      "getSelectedCountries",
      "getSelectedSectors",
      "countrySelected",
      "sectorSelected",
      "capitalTypeSelected",
      "providerTypeSelected",
      "femaleFocusSelected",
      "providerList",
      "loadingResults"
    ])
  },
  methods: {
    ...mapActions({
      fetchProvider: "fetchProvider",
      search: "search"
    }),
    ...mapMutations({
      setCapitalType: "setCapitalTypesParam",
      setProvidersType: "setProviderTypesParam",
      setSector: "setSectorsParam",
      setFemaleFocus: "setFemaleFocusParam"
    }),
    toggleFemaleFocus: function() {
      this.setFemaleFocus(!this.femaleFocusSelected);
    },
    navToProviderProfile: function(provider) {
      if (provider.hasOwnProperty("name")) {
        var urlParam = slugify(provider.name, { lower: true });
        this.$router.push({
          name: "Profile",
          params: { providerName: urlParam }
        });
      }
    }
  },
  created() {
    // this.navToProviderProfile(this.providerList[10])
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/Directory.vue